import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'

function useGTM() {
  const { pathname } = useLocation()
  const isInitialized = useRef(false)

  useEffect(() => {
    if (isInitialized.current) return

    let gtmId = 'GTM-N8LQSVFS'


    TagManager.initialize({ gtmId })
    isInitialized.current = true
  }, [pathname])
}

export default useGTM
